// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1F6UH","upload":"Small_upload__2LFGz","imageWrap":"Small_imageWrap__2cu5F","removeBtn":"Small_removeBtn__3aHTZ"};